module.exports = __webpack_public_path__ + "media/images/lp/lp26-1c6af7645a6d6703f640ce6b31957a9b.webp";